import styled from 'styled-components'
import theme from '../../styles/theme'

export const Wrapper = styled.div`
  margin: 25% 25% 25% 25%;
  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  label {
    border-width: 0;
  }
  .inputfile + label {
    font-size: 1.25em;
    font-weight: 700;
    color: ${theme.colors.darkGray};
    display: inline-block;
  }

  .inputfile + label {
    cursor: pointer;
  }
`
